/** Public path segment for sideload APK files (Caddy → infrastructure/android-releases). */
export const ANDROID_APK_DOWNLOAD_PATH_PREFIX = '/download/android';

export const ANDROID_APK_FALLBACK_FILE = 'umnaya-smena.apk';

export const ANDROID_APK_PUBLIC_ORIGIN = 'https://app.pick-pvz.ru';

export function sanitizeAndroidVersionForFileName(versionName: string): string {
  const trimmed = versionName.trim();
  const safe = trimmed.replace(/[^0-9A-Za-z._-]+/g, '-').replace(/^-+|-+$/g, '');
  return safe || 'latest';
}

export function androidApkFileName(versionName: string): string {
  return `umnaya-smena-${sanitizeAndroidVersionForFileName(versionName)}.apk`;
}

export function androidApkDownloadPath(versionName: string): string {
  return `${ANDROID_APK_DOWNLOAD_PATH_PREFIX}/${androidApkFileName(versionName)}`;
}

export function androidApkDownloadUrl(versionName: string, origin = ANDROID_APK_PUBLIC_ORIGIN): string {
  return `${origin}${androidApkDownloadPath(versionName)}`;
}

export const ANDROID_APK_FALLBACK_URL = `${ANDROID_APK_PUBLIC_ORIGIN}${ANDROID_APK_DOWNLOAD_PATH_PREFIX}/${ANDROID_APK_FALLBACK_FILE}`;
